import actionTypes from './action-types';

export default (state = {}, action) => {
    switch (action.type) {
        case actionTypes.INITIALIZE:
            return {
                ...action.payload
            };
        case actionTypes.DEFAULT_ACTION:
            return {
                ...state,
                default: action.payload
            };
        default:
            return state;
    }
};
